import BaseAPIHelper from 'services/BaseAPIHelper';
export const getWeChatSignature = (input) => {
  const url = `/we-chat/signature`;
  return BaseAPIHelper.post({ link: url, input });
};
